"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var Merrco_1 = require("../../models/Payments/Merrco");
var models_1 = require("../../models");
exports.generateBirchmountUrl = function (path) { return "" + __1.BIRCHMOUNT_BASE_URL + path; };
exports.BirchmountAPI = {
    getAccessToken: function (username, password, params) { return __awaiter(_this, void 0, void 0, function () {
        var res, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.axios.post(exports.generateBirchmountUrl('/api_get_token'), undefined, {
                        headers: {
                            Authorization: Merrco_1.base64Encryption(username + ":" + password)
                        },
                        params: params
                    })];
                case 1:
                    res = _a.sent();
                    response = {
                        STATUS: res.data.response.STATUS,
                        MSG: res.data.response.MSG,
                        TOKEN: res.data.response.TOKEN,
                        expires: res.headers.expires
                    };
                    return [2 /*return*/, response];
            }
        });
    }); },
    checkBalance: function (accessToken, params) { return __awaiter(_this, void 0, void 0, function () {
        var res, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.axios.get(exports.generateBirchmountUrl('/api_check_balance'), {
                        headers: { Authorization: accessToken },
                        params: params
                    })];
                case 1:
                    res = _a.sent();
                    response = res.data.response;
                    return [2 /*return*/, models_1.convertBalanceToNumber(response)];
            }
        });
    }); },
    activate: function (accessToken, params) { return __awaiter(_this, void 0, void 0, function () {
        var res, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.axios.post(exports.generateBirchmountUrl('/api_activate_card'), undefined, {
                        headers: { Authorization: accessToken },
                        params: params
                    })];
                case 1:
                    res = _a.sent();
                    response = res.data.response;
                    return [2 /*return*/, models_1.convertBalanceToNumber(response)];
            }
        });
    }); },
    redeem: function (accessToken, params) { return __awaiter(_this, void 0, void 0, function () {
        var res, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.axios.post(exports.generateBirchmountUrl('/api_redeem_card'), undefined, {
                        headers: { Authorization: accessToken },
                        params: params
                    })];
                case 1:
                    res = _a.sent();
                    response = res.data.response;
                    return [2 /*return*/, models_1.convertBalanceToNumber(response)];
            }
        });
    }); },
    reload: function (accessToken, params) { return __awaiter(_this, void 0, void 0, function () {
        var res, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.axios.post(exports.generateBirchmountUrl('/api_reload_card'), undefined, {
                        headers: { Authorization: accessToken },
                        params: params
                    })];
                case 1:
                    res = _a.sent();
                    response = res.data.response;
                    return [2 /*return*/, models_1.convertBalanceToNumber(response)];
            }
        });
    }); },
    reverse: function (accessToken, params) { return __awaiter(_this, void 0, void 0, function () {
        var res, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.axios.post(exports.generateBirchmountUrl('/api_reverse_transaction'), undefined, {
                        headers: { Authorization: accessToken },
                        params: params
                    })];
                case 1:
                    res = _a.sent();
                    response = res.data.response;
                    return [2 /*return*/, models_1.convertBalanceToNumber(response)];
            }
        });
    }); },
    getLocationIds: function (params, accessToken) { return __awaiter(_this, void 0, void 0, function () {
        var res, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.axios.get(exports.generateBirchmountUrl('/api_get_location_list'), {
                        headers: accessToken ? { Authorization: accessToken } : undefined,
                        params: params
                    })];
                case 1:
                    res = _a.sent();
                    response = res.data.response;
                    return [2 /*return*/, response];
            }
        });
    }); }
};
//# sourceMappingURL=BirchmountAPI.js.map